import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import _isArray from "lodash/isArray";
var _excluded = ["linkTo", "icon", "label", "styles"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Tooltip, Icon } from 'components/UI';
import { tooltipListItem, tableActionsLabel } from './styles'; // eslint-disable-next-line max-len

import { jsx as ___EmotionJSX } from "@emotion/react";
var externalLinkExpression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i;

var TableActions = function TableActions(_ref) {
  var mainAction = _ref.mainAction,
      actionsList = _ref.actionsList,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'left' : _ref$position;
  return ___EmotionJSX(React.Fragment, null, mainAction && ___EmotionJSX(Button, _extends({
    small: true,
    margin: "0 8px 0 0"
  }, mainAction)), _isArray(actionsList) && actionsList.filter(Boolean).length > 0 && ___EmotionJSX(Tooltip, {
    noArrow: true,
    onClick: true,
    closeOnClick: true,
    singleLine: true,
    placement: position,
    backgroundColor: "white",
    color: "gray50",
    padding: 0,
    border: function border(t) {
      return "1px solid ".concat(t.gray100);
    },
    content: ___EmotionJSX("ul", null, actionsList.filter(Boolean).map(function (_ref2) {
      var linkTo = _ref2.linkTo,
          icon = _ref2.icon,
          label = _ref2.label,
          styles = _ref2.styles,
          restProps = _objectWithoutProperties(_ref2, _excluded);

      var isExternalLink = externalLinkExpression.test(linkTo === null || linkTo === void 0 ? void 0 : linkTo.pathname);
      var Component = linkTo ? isExternalLink ? 'a' : Link : 'li';
      return ___EmotionJSX(Component, _extends({
        key: label
      }, !isExternalLink && !linkTo && {
        role: 'button',
        tabIndex: 0
      }, linkTo && !isExternalLink && {
        to: linkTo
      }, isExternalLink && {
        href: linkTo === null || linkTo === void 0 ? void 0 : linkTo.pathname,
        target: '_blank'
      }, {
        css: tooltipListItem(styles)
      }, restProps), icon && ___EmotionJSX(Icon, _extends({
        margin: "0 0.5em 0 0",
        size: 20
      }, icon)), ___EmotionJSX("span", null, label));
    }))
  }, ___EmotionJSX("span", {
    css: tableActionsLabel
  }, "...")));
};

TableActions.propTypes = {
  mainAction: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  actionsList: PropTypes.array,
  position: PropTypes.string
};
export default TableActions;